

































import { Component, Vue} from 'vue-property-decorator';
import { ITodoTypeOptions, todoTypeTool } from '@/utils/todo';
import { pubsub, CLOSE_TAG_VIEW_EVENT } from '@/utils/pubsub';
import { generateLeaderTeams } from '@/utils/team';
import { AccountModule } from '@/store/modules/account';
import { generateUUID } from '@/utils/other';
import { todoListInstance } from '@/model/TodoListClass';
import { filterSettlementUnits, getAllSettlementUnits } from '@/utils/settlementUnit';
import TodoForm from './todoForm.vue';
import { deepClone } from '@/utils/deepClone';
import {IFormItemInfo} from '../types';

type IUserDetailInfo = IUser.IResponse.IUserDetailInfo;
type ISettlementUnitInfo = ISettlementUnit.IResponse.ISettlementUnitInfo;


function createNewFormItem(params?: Partial<IFormItemInfo>) {
  const baseFormItem: IFormItemInfo = {
    formId: generateUUID(),
    moduleId: '',
    typeId: [],
    typeName: '',
    title: '',
    description: '',
    owners: [],
    due: null,
    dues: [],
    isBatchCreate: false,
    checkBoxDates: [],
    typeValue: null,
    ownerValue: 0,
    isGrab: false,
    grabInfo: null,
  };
  if (params) {
    return Object.assign(baseFormItem, params);
  }
  return baseFormItem;
}

@Component({
  components: {
    TodoForm,
  },
})
export default class TodoFormList extends Vue {
  private todoTypeOptions: ITodoTypeOptions[] = [];
  private memberOptions: IUserDetailInfo[] = [];
  private settlementUnitOptions: ISettlementUnitInfo[] = [];
  private submitLoading: boolean = false;
  private todoListInstance = todoListInstance;
  private projectName = '';
  private ownerValue: number = 0;
  get todoForCreate() {
    return this.todoListInstance.todoForCreate;
  }
  private formList: IFormItemInfo[] = [];
  private created() {
    this.readyFormData();
    this.initTypeOptions();
    generateLeaderTeams(AccountModule.userDetailInfo!.id).then((res) => {
      this.memberOptions = res;
    }).catch((err) => err);
    getAllSettlementUnits().then(() => {
      this.settlementUnitOptions = filterSettlementUnits('active', true);
    }).catch((err) => err);
  }
  private readyFormData() {
    if (this.todoForCreate) {
      const {
        moduleId,
        title,
        description,
        projectName,
      } = this.todoForCreate;
      this.formList = [createNewFormItem({moduleId, title, description})];
      this.projectName = projectName || '';
    }
  }
  private initTypeOptions() {
    const projectId = this.todoForCreate?.projectId;
    if (!projectId) {
      this.todoTypeOptions = [];
      return;
    }
    todoTypeTool.requestGetTodoTypes().then(() => {
      this.todoTypeOptions = todoTypeTool.cascadedData[projectId] || [];
    }).catch((err) => {
      this.$message.warning(err);
    });
  }
  private handleSubmit() {
    const allTodoList: ITodo.IRequest.IBatchCreateTodoParams[] = [];
    let validateResult = true;
    for (const formItem of this.formList) {
      const formItemRef = (this.$refs['form-' + formItem.formId] as TodoForm[])[0];
      if (formItemRef.validate()) {
        allTodoList.push(...formItemRef.generateTodoData());
      } else {
        validateResult = false;
      }
    }
    if (validateResult) {
      this.submitLoading = true;
      todoListInstance.requestBatchCreateTodo(allTodoList).then((res) => {
        this.submitLoading = false;
        this.$message.success(res);
        this.goBack();
      }).catch((err) => {
        this.submitLoading = false;
        this.$message.warning(err);
      });
    }
  }
  private goBack() {
    pubsub.publish(CLOSE_TAG_VIEW_EVENT, this.$route.path);
    this.$router.push({name: 'Todo'});
  }
  private removeForm(index: number) {
    this.formList.splice(index, 1);
  }
  private copyForm(form: IFormItemInfo) {
    const data: IFormItemInfo = deepClone(form);
    data.formId = generateUUID();
    const patt = /_copy\[\d+\]/g;
    if (!patt.test(data.title)) {
      data.title = form.title + `_copy[${this.formList.length}]`;
    } else {
      data.title = data.title.replace(patt, `_copy[${this.formList.length}]`);
    }
    this.formList.push(createNewFormItem(data));
  }
  private addForm() {
    if (!this.todoForCreate) {
      return;
    }
    const {
      moduleId,
      title,
      description,
    } = this.todoForCreate;
    this.formList.push(createNewFormItem({moduleId, title, description}));
  }
}
